export const currentDate = () => {
  const d = new Date(Date.now());
  const month = d.getMonth() + 1;
  const day = d.getDate();
  const year = d.getFullYear();

  return [day, month, year].join(".");
};
